import { getAuthHeaders, makeApiCall } from '../utils/apiConfig';

export interface VendorPriceClockProgram {
  match: string;
  label?: string;
  timeZone?: string;
  startTime?: string;
  endTime?: string;
}

export interface VendorPriceClockInput {
  brandName: string;
  timeZone: string;
  startTime: string;
  endTime: string;
  enabled: boolean;
  programs?: VendorPriceClockProgram[];
  sourceNote?: string;
  confidence?: 'high' | 'medium' | 'low';
}

export interface VendorPriceClock extends VendorPriceClockInput {
  brandKey: string;
  origin: 'seed' | 'stored';
  updatedAt?: string | null;
  updatedBy?: string | null;
}

async function readError(response: Response, fallback: string): Promise<string> {
  const body = await response.json().catch(() => ({}));
  return body?.error?.message || body?.message || fallback;
}

export const vendorPriceClockApi = {
  list: async (): Promise<{ clocks: VendorPriceClock[]; flagEnabled: boolean }> => {
    const response = await makeApiCall('/admin/vendor-price-clocks', { headers: await getAuthHeaders() });
    if (!response.ok) throw new Error(await readError(response, 'Failed to load price clocks'));
    return (await response.json()).data;
  },
  save: async (brandKey: string, input: VendorPriceClockInput): Promise<VendorPriceClock> => {
    const response = await makeApiCall(`/admin/vendor-price-clocks/${encodeURIComponent(brandKey)}`, {
      method: 'PUT',
      headers: { ...(await getAuthHeaders()), 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });
    if (!response.ok) throw new Error(await readError(response, 'Failed to save the price clock'));
    return (await response.json()).data;
  },
  reset: async (brandKey: string): Promise<{ message: string }> => {
    const response = await makeApiCall(`/admin/vendor-price-clocks/${encodeURIComponent(brandKey)}`, {
      method: 'DELETE',
      headers: await getAuthHeaders(),
    });
    if (!response.ok) throw new Error(await readError(response, 'Failed to reset the price clock'));
    return response.json();
  },
};
